import React, { FC } from 'react';

interface IComponentProps {
  show?: boolean;
  background?: string;
  marginY: number;
}

export const Divider: FC<IComponentProps> = ({ show = true, background = '#dcdfe1', marginY }) => {
  return show ? (
    <div className="divider" style={{ width: '100%', minHeight: '1px', background, margin: `${marginY}px 0` }} />
  ) : null;
};
